import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "first-name" }, "Meno", -1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "last-name" }, "Priezvisko", -1)
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "company" }, "Spoločnosť", -1)
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "w-full",
  for: "department"
}, "Oddelenie", -1)
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1)
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Mobil", -1)
const _hoisted_16 = { class: "flex align-items-center justify-content-center" }
const _hoisted_17 = {
  key: 0,
  class: "w-4 mb-2 flex align-items-center justify-content-start"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "changedPasswd",
  class: "ml-2"
}, "Zmeniť heslo", -1)
const _hoisted_19 = {
  key: 0,
  class: "field"
}
const _hoisted_20 = {
  class: "w-full",
  for: "passwd"
}
const _hoisted_21 = {
  key: 1,
  class: "field"
}
const _hoisted_22 = {
  class: "w-full",
  for: "repasswd"
}
const _hoisted_23 = { class: "flex align-items-center justify-content-center" }
const _hoisted_24 = { class: "w-4 flex align-items-center justify-content-start" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "admin",
  class: "ml-2"
}, "Správca systému", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_27 = { class: "mt-2 flex flex-wrap justify-content-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevuePassword = _resolveComponent("PrimevuePassword")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PrimevueCard, { class: "sm:w-6 md:w-6 lg:w-5 xl:w-4" }, {
        title: _withCtx(() => [
          _createTextVNode("UŽÍVATEĽ")
        ]),
        subtitle: _withCtx(() => [
          _hoisted_2
        ]),
        content: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
            name: "userForm"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputText, {
                class: _normalizeClass(["w-full", `${$setup.v$.user.firstName.$error ? 'bg-red-200' : ''}`]),
                invalid: $setup.v$.user.firstName.$error,
                modelValue: this.user.firstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.user.firstName) = $event)),
                type: "text",
                name: "first-name",
                id: "first-name"
              }, null, 8, ["class", "invalid", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.user.firstName.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "text-sm font-italic text-red-400"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                class: _normalizeClass(["w-full", `${$setup.v$.user.lastName.$error ? 'bg-red-200' : ''}`]),
                invalid: $setup.v$.user.lastName.$error,
                modelValue: this.user.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.user.lastName) = $event)),
                type: "text",
                name: "last-name",
                id: "last-name"
              }, null, 8, ["class", "invalid", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.user.lastName.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "text-sm font-italic text-red-400"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_InputText, {
                class: "w-full",
                modelValue: this.user.company,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.user.company) = $event)),
                type: "text",
                name: "company",
                id: "company"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives((_openBlock(), _createElementBlock("span", null, [
                _createVNode(_component_PrimevueSelect, {
                  disabled: !$data.store.user.admin,
                  id: "department",
                  modelValue: this.selectDepartment,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.selectDepartment) = $event)),
                  options: this.departOptions,
                  class: "w-full"
                }, {
                  value: _withCtx((slotProps) => [
                    _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "options"])
              ])), [
                [
                  _directive_tooltip,
                   'Týmto vyberáš aj oprávnenia užívateľa' ,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_InputText, {
                class: _normalizeClass(["w-full", `${$setup.v$.user.email.$error ? 'bg-red-200' : ''}`]),
                invalid: $setup.v$.user.email.$error,
                modelValue: this.user.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.user.email) = $event)),
                type: "email",
                name: "email",
                id: "email"
              }, null, 8, ["class", "invalid", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.user.email.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "text-sm font-italic text-red-400"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_InputText, {
                class: _normalizeClass(["w-full", `${$setup.v$.user.phone.$error ? 'bg-red-200' : ''}`]),
                invalid: $setup.v$.user.phone.$error,
                modelValue: this.user.phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.user.phone) = $event)),
                type: "text",
                name: "phone",
                id: "phone"
              }, null, 8, ["class", "invalid", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.user.phone.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "text-sm font-italic text-red-400"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_16, [
              (!(this.user.id===0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_PrimevueCheckbox, {
                      class: "",
                      modelValue: this.changedPasswd,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.changedPasswd) = $event)),
                      inputId: "changedPasswd",
                      name: "changedPasswd",
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true)
            ]),
            (this.user.id===0 || this.changedPasswd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(this.changedPasswd ? "Nové heslo" : "Heslo"), 1),
                  _createVNode(_component_PrimevuePassword, {
                    modelValue: this.user.passwd,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.user.passwd) = $event)),
                    name: "passwd",
                    id: "passwd",
                    promptLabel: "Zadaj heslo (min. 8 znakov)",
                    weakLabel: "Príliš slabé",
                    mediumLabel: "Slabé",
                    strongLabel: "Silné",
                    toggleMask: ""
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (this.user.id===0 || this.changedPasswd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(this.changedPasswd ? "Nové heslo znovu" : "Heslo znovu"), 1),
                  _createVNode(_component_PrimevuePassword, {
                    modelValue: this.user.repasswd,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.user.repasswd) = $event)),
                    inputClass: `${$setup.v$.user.repasswd.$error ? 'bg-red-200' : ''}`,
                    invalid: $setup.v$.user.repasswd.$error,
                    name: "repasswd",
                    id: "repasswd",
                    promptLabel: "Zadaj heslo (min. 8 znakov)",
                    weakLabel: "Príliš slabé",
                    mediumLabel: "Slabé",
                    strongLabel: "Silné",
                    toggleMask: ""
                  }, null, 8, ["modelValue", "inputClass", "invalid"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.user.repasswd.$errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "text-sm font-italic text-red-400"
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_PrimevueCheckbox, {
                  disabled: !$data.store.user.admin,
                  modelValue: this.user.admin,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.user.admin) = $event)),
                  inputId: "admin",
                  name: "admin",
                  binary: true,
                  onChange: $options.handleAdminChange
                }, null, 8, ["disabled", "modelValue", "onChange"]),
                _hoisted_25
              ])
            ]),
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_PrimevueButton, {
                type: "submit",
                label: "Uložiť",
                text: "",
                raised: "",
                class: "uppercase"
              }),
              _createVNode(_component_router_link, {
                to: $data.store.user.admin ? '/admin/users' : '/'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimevueButton, {
                    label: "Zrušiť",
                    severity: "danger",
                    text: "",
                    raised: "",
                    class: "uppercase"
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}